/**
 * BD Coupon Logik (Birthday Sale) – portiert aus dem Live-Theme (assets/custom.js).
 * Module: Click-to-Apply (/discount/CODE), Countdown, Anzeige-Logik (Bars, Karten, PDP).
 * Benötigt: COUPON_ENTRY_INFO_LIST (siehe snippets/bd-coupon-init.liquid).
 *
 * Erweiterung: Klick auf den Code schaltet sofort + persistent (localStorage)
 * in den Aktiv-Zustand (grüne Leiste), unabhängig vom Warenkorb-Inhalt.
 */
(function () {
  'use strict';

  var ENTRIES = typeof COUPON_ENTRY_INFO_LIST !== 'undefined' ? COUPON_ENTRY_INFO_LIST : [];
  var ACTIVATED_KEY = 'bd_coupon_activated';
  /* true, solange ein Klick gerade den Code im Warenkorb anwendet – verhindert
     ein kurzes Zurückspringen auf "inaktiv" (Flackern grün → orange → grün). */
  var applying = false;

  /* ---------- Helpers ---------- */
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function formatMoney(cents, symbol) {
    return (Math.ceil(parseInt(cents, 10)) / 100).toFixed(2).replace('.', ',') + ' ' + symbol;
  }
  function discountedCents(cents, percent) {
    return Math.ceil(parseInt(cents, 10) * (100 - percent) / 100);
  }
  function setHtml(el, html) {
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  function maxDiscountPercent(entry, idListString) {
    var ids = (idListString || '').trim().split(',');
    var percent = 0;
    ids.forEach(function (id) {
      if (id === '') return;
      (entry.collection_discount_percent_list || []).forEach(function (item) {
        if (String(item.collection_id) === String(id).trim() && item.discount_percent > percent) {
          percent = item.discount_percent;
        }
      });
    });
    return percent;
  }
  function entryActive(entry) {
    var end = new Date(entry.end_date);
    var now = new Date(entry.current_date);
    return !isNaN(end.getTime()) && !isNaN(now.getTime()) && end - now > 0;
  }

  /* Persistierter Aktiv-Zustand (per Klick gesetzt) */
  function getActivatedCode() {
    try { return localStorage.getItem(ACTIVATED_KEY); } catch (e) { return null; }
  }
  function setActivatedCode(code) {
    try { localStorage.setItem(ACTIVATED_KEY, code); } catch (e) {}
  }
  function clearActivatedCode() {
    try { localStorage.removeItem(ACTIVATED_KEY); } catch (e) {}
  }
  function activatedEntry() {
    var code = getActivatedCode();
    if (!code) return null;
    var match = null;
    ENTRIES.forEach(function (entry) {
      if (entry.code_title === code) match = entry;
    });
    if (match && !entryActive(match)) {
      clearActivatedCode();
      return null;
    }
    return match;
  }

  /* Welcher Eintrag soll angezeigt werden?
     - Warenkorb hat den Code => aktiv (grün), Merker setzen.
     - Warenkorb hat Artikel, aber keinen gültigen Code => Code wurde entfernt
       => zurück auf inaktiv (orange), Merker löschen.
     - Leerer Warenkorb => optimistischen Klick-Zustand (localStorage) halten. */
  function decideEntry() {
    /* Während des Anwendens nicht auf inaktiv zurückfallen – aktiven Zustand halten */
    if (applying) {
      return findAppliedEntry(lastDiscountCodes) || activatedEntry();
    }
    var cartEntry = findAppliedEntry(lastDiscountCodes);
    if (cartEntry) {
      setActivatedCode(cartEntry.code_title);
      return cartEntry;
    }
    if ((lastItemCount || 0) > 0) {
      clearActivatedCode();
      return null;
    }
    return activatedEntry();
  }

  /* ---------- 1) Klick auf Code => sofort umschalten + /discount/CODE einlösen ---------- */
  document.addEventListener('click', function (e) {
    var wrapper = e.target.closest('[js-discount-appliable-wrapper]');
    if (!wrapper) return;
    var codeEl = wrapper.querySelector('[data-code]');
    var code = codeEl && codeEl.getAttribute('data-code');
    if (!code) return;

    /* Aktiv-Zustand merken und sofort visuell umschalten */
    setActivatedCode(code);
    applyDisplay(activatedEntry());

    /* Code echt im Warenkorb anwenden (ohne Reload) + Warenkorb-Drawer neu rendern */
    applyDiscountCode(code);
  });

  /* Wendet den Rabattcode echt auf den Warenkorb an (wie die Theme-eigene
     cart-discount-Logik) und rendert den Warenkorb-Drawer neu – ohne Reload. */
  function applyDiscountCode(code) {
    applying = true;
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var updateUrl = routes.cart_update_url || '/cart/update';
    if (updateUrl.indexOf('.js') === -1) updateUrl += '.js';
    var cartUrl = routes.cart_url || '/cart';

    /* Sektionen sammeln, die das Theme nach einer Warenkorb-Änderung neu rendert */
    var sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
    } catch (e) {}

    var fd = new FormData();
    fd.append('discount', code);
    fd.append('sections', sections.join(','));
    fd.append('sections_url', window.location.pathname);

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (parsed) {
        return fetch(cartUrl + '.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cartJson) {
            cartJson.sections = parsed.sections;
            /* Theme-eigene Render-Pipeline: rendert Warenkorb-Drawer neu */
            if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            }
            lastDiscountCodes = cartJson.discount_codes || [];
            lastItemCount = cartJson.item_count || 0;
            applying = false;
            applyDisplay(decideEntry());
          });
      })
      .catch(function () {
        applying = false;
        /* Fallback: klassisch über /discount/CODE (ohne die Seite zu verlassen) */
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { refresh(); })
          .catch(function () {});
      });
  }

  /* ---------- 2) Countdown DD:HH:MM:SS für [js-coupon-left-time] ---------- */
  function initTimer(el) {
    if (el.hasAttribute('data-countdown-inited')) return;
    el.setAttribute('data-countdown-inited', 'true');
    var end = new Date(el.getAttribute('js-coupon-left-time'));
    var serverNowAttr = el.getAttribute('js-current-time');
    var serverNow = serverNowAttr ? new Date(serverNowAttr) : new Date();
    if (isNaN(end.getTime()) || isNaN(serverNow.getTime())) return;
    var baseDiff = end - serverNow;
    var startedAt = Date.now();
    var interval = null;
    function tick() {
      var remaining = baseDiff - (Date.now() - startedAt);
      if (remaining <= 0) {
        el.textContent = '00:00:00:00';
        if (interval) clearInterval(interval);
        return;
      }
      var s = Math.floor(remaining / 1000);
      el.textContent = pad(Math.floor(s / 86400)) + ':' + pad(Math.floor(s / 3600) % 24) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    }
    tick();
    interval = setInterval(tick, 1000);
  }
  function initAllTimers(root) {
    (root || document).querySelectorAll('[js-coupon-left-time]').forEach(initTimer);
  }

  /* ---------- 3) Anzeige-Logik ---------- */
  function findAppliedEntry(discountCodes) {
    var found = null;
    (discountCodes || []).forEach(function (dc) {
      if (!dc || dc.applicable === false) return;
      ENTRIES.forEach(function (entry) {
        if (dc.code === entry.code_title) found = entry;
      });
    });
    if (found && !entryActive(found)) found = null;
    return found;
  }

  function applyDisplay(entry) {
    /* Header-Bars */
    document.querySelectorAll('.bd-coupon-bar-applied--wrapper').forEach(function (el) {
      if (!entry) {
        el.classList.add('d-none');
        return;
      }
      el.classList.remove('d-none');
      var templateText = el.querySelector('[data-template]');
      if (templateText) {
        setHtml(templateText, String(templateText.getAttribute('data-template')).replace('((code))', entry.code_title));
      }
    });
    document.querySelectorAll('.bd-coupon-bar--wrapper').forEach(function (el) {
      if (entry) el.classList.add('d-none');
      else el.classList.remove('d-none');
    });

    /* Produktkarten */
    document.querySelectorAll('product-card').forEach(function (card) {
      var withCoupon = card.querySelectorAll('.card__badge-with-coupon, .card__price-with-coupon');
      var withoutCoupon = card.querySelectorAll('.card__price-without-coupon');
      var percent = 0;
      if (entry) percent = maxDiscountPercent(entry, card.getAttribute('data-collection-id-list'));
      if (!entry || percent === 0) {
        withCoupon.forEach(function (el) { el.classList.add('d-none'); });
        withoutCoupon.forEach(function (el) { el.classList.remove('d-none'); });
        return;
      }
      var soldOut = !!card.querySelector('.f-price--sold-out') || !!card.querySelector('.f-badge--soldout');
      withCoupon.forEach(function (el) { el.classList.remove('d-none'); });
      withoutCoupon.forEach(function (el) { el.classList.add('d-none'); });
      card.querySelectorAll('.card__badge-with-coupon').forEach(function (el) {
        if (soldOut) { el.classList.add('d-none'); return; }
        setHtml(el, '-' + percent + '%');
      });
      card.querySelectorAll('.card__price-with-coupon .price').forEach(function (el) {
        var cents = el.closest('.card__price-with-coupon').getAttribute('data-price');
        setHtml(el, formatMoney(cents, entry.currency_symbol));
      });
      card.querySelectorAll('.card__price-with-coupon .discounted-price').forEach(function (el) {
        var cents = el.closest('.card__price-with-coupon').getAttribute('data-price');
        setHtml(el, formatMoney(discountedCents(cents, percent), entry.currency_symbol));
      });
    });

    /* PDP Preisblock (Sonderpreis) */
    document.querySelectorAll('.price__container-with-coupon').forEach(function (container) {
      var percent = 0;
      if (entry) percent = maxDiscountPercent(entry, container.getAttribute('data-collection-id-list'));
      if (!entry || percent === 0) {
        container.classList.add('d-none');
        if (container.nextElementSibling) container.nextElementSibling.classList.remove('d-none');
        return;
      }
      container.classList.remove('d-none');
      if (container.nextElementSibling) container.nextElementSibling.classList.add('d-none');
      var cents = container.getAttribute('data-price');
      container.querySelectorAll('.price--wrapper .value').forEach(function (el) {
        setHtml(el, formatMoney(cents, entry.currency_symbol));
      });
      container.querySelectorAll('.discount-price--wrapper .value').forEach(function (el) {
        setHtml(el, formatMoney(discountedCents(cents, percent), entry.currency_symbol));
      });
      container.querySelectorAll('.discount-price--wrapper .badge').forEach(function (el) {
        setHtml(el, String(el.getAttribute('data-template')).replace('((percent))', percent).replace('((title))', entry.code_title));
      });
      container.querySelectorAll('[js-coupon-left-time]').forEach(function (el) {
        if (el.getAttribute('js-coupon-left-time') !== entry.end_date) {
          el.setAttribute('js-coupon-left-time', entry.end_date);
          el.setAttribute('js-current-time', entry.current_date);
          el.removeAttribute('data-countdown-inited');
        }
      });
      initAllTimers(container);
    });
  }

  var lastDiscountCodes = null;
  var lastItemCount = 0;
  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastDiscountCodes = cart.discount_codes || [];
        lastItemCount = cart.item_count || 0;
        applyDisplay(decideEntry());
      })
      .catch(function () {
        applyDisplay(activatedEntry());
      });
  }

  function init() {
    initAllTimers(document);
    /* Sofort den ggf. per Klick aktivierten Zustand anzeigen (vor dem cart.js-Fetch) */
    applyDisplay(activatedEntry());
    refresh();
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'variant:change:end'].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });

    /* Später gerenderte Elemente (Slider, Quick-View, Empfehlungen) */
    var debounce = null;
    var observer = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        var elT = t.nodeType === 1 ? t : t.parentElement;
        if (!elT) continue;
        if (elT.closest('[js-coupon-left-time]')) continue;
        relevant = true;
        break;
      }
      if (!relevant) return;
      // Sofort-Korrektur: verhindert kurzes Aufblitzen des Preises OHNE Rabatt,
      // wenn das Theme beim Varianten-Wechsel den PDP-Preisblock neu rendert.
      var healEntry = (lastDiscountCodes !== null) ? decideEntry() : activatedEntry();
      if (healEntry) {
        var needFix = false;
        document.querySelectorAll('.price__container-with-coupon.d-none').forEach(function (c) {
          if (maxDiscountPercent(healEntry, c.getAttribute('data-collection-id-list')) > 0) needFix = true;
        });
        if (needFix) applyDisplay(healEntry);
      }
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function () {
        initAllTimers(document);
        if (lastDiscountCodes !== null) applyDisplay(decideEntry());
        else applyDisplay(activatedEntry());
      }, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
